import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import _ from 'lodash';

export function HubListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.HubListing', {
		url: '/admin/hubs',
		controllerAs: 'vm',
		controller: HubListingCtrl,
		templateUrl: '/ng/hub/Hub/Listing/HubListingCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Hub/Listing/HubListingCtrl.css'),
			$title: () => 'All Hubs',
		},
	});
}

export class HubListingCtrl {
	constructor($state, Api, Identity, modal) {
		'ngInject';
		// save injections
		this.$state = $state;
		this.Identity = Identity;
		this.Api = Api;
		this.modal = modal;
		// reset filters
		this.filters = {
			account: '',
			hub: '',
		};
		// set initial values
		this.gatherHubs();
		this.currentHub = this.Identity.currentClient();
	}

	gatherHubs() {
		const accountsByName = {};
		this.Identity.user().hubs.forEach(hub => {
			if (!accountsByName[hub.account]) {
				accountsByName[hub.account] = {
					id: hub.account_id,
					name: hub.account,
					hubs: [],
				};
			}
			accountsByName[hub.account].hubs.push({
				...hub,
				name: hub.name.replace(/^.+› /, ''),
			});
		});
		this.accounts = _.values(accountsByName);
	}

	newHub() {
		this.modal
			.state('hub.loggedin.AffiliationNewHub', {
				heading: 'New Hub',
				width: 750,
				height: 600,
				attemptFocus: true,
			})
			.then(() => {
				return this.Identity.load();
			})
			.then(
				() => {
					this.gatherHubs();
				},
				() => {}
			);
	}

	useHub(hub) {
		this.Identity.useHub(hub.id).then(() => {
			// This is a superadmin page, so it doesn't respect the `Features.home_page_on_hub_switch` setting
			this.$state.reload();
		});
	}
}
